import { useQuery as e } from "@maat/store-hooks";
import { workspacesApi as t } from "@maat/api-main";
//#region src/workspaces/useAdminWorkspaceOptionsQuery.ts
var n = (n) => e({
	queryKey: ["admin-workspace-options", n ?? ""],
	queryFn: () => t.adminSearchWorkspaceOptions({ search: n })
});
//#endregion
export { n as useAdminWorkspaceOptionsQuery };
